export const NEWSLETTER_MESSAGES = {
  SUCCESS: "Langganan anda berjaya.", // Your subscription is successful.
  UNSUB_SUCCESS: "Langganan anda berjaya dikemas kini.", // Your subscription has been successfully updated.
  FAILED: "Langganan anda terdapat masalah.", // There is a problem with your subscription.
  INVALID_EMAIL: "Alamat email tidak sah", // Invalid email address
};

export const NEWSLETTER_CONTACT_LIST_ID = "934866939";

// Feature flag: when enabled, the newsletter form submits via the Consent v3
// API (/_plat/api/v1/consent/sync). When disabled, it falls back to the legacy
// newsletterSignup endpoint. Toggle by setting VITE_ENABLE_CONSENT_V3_NEWSLETTER=1.
export const ENABLE_CONSENT_V3_NEWSLETTER =
  import.meta.env.VITE_ENABLE_CONSENT_V3_NEWSLETTER === "1";
